<section class="profile-cards-list">
  @if (list.length > 0 && !isLoading) {
    <ul class="profile-cards-list__grid">
      @for (item of list; track item._id ?? $index) {
        <li class="profile-cards-list__item">
          @if (item._id) {
            <a
              [routerLink]="getDetailRoute(item)"
              [state]="getNavigationState(item)"
              class="profile-cards-list__link">
              @switch (getCardTypeForProfile(item)) {
                @case ('SUPPLIER') {
                  <pwj-supplier-profile-card
                    [profile]="item"
                    [cardType]="getCardTypeForProfile(item)"
                    [canViewDetails]="canViewDetails()" />
                }
                @case ('INSTALLER') {
                  <pwj-installer-profile-card
                    [profile]="item"
                    [cardType]="getCardTypeForProfile(item)"
                    [canViewDetails]="canViewDetails()" />
                }
                @case ('PROJECT_OWNER') {
                  <pwj-developer-profile-card
                    [profile]="item"
                    [cardType]="getCardTypeForProfile(item)"
                    [canViewDetails]="canViewDetails()" />
                }
                @case ('ARCHITECT') {
                  <pwj-architect-profile-card
                    [profile]="item"
                    [cardType]="getCardTypeForProfile(item)"
                    [canViewDetails]="canViewDetails()" />
                }
                @default {
                  <pwj-supplier-profile-card
                    [profile]="item"
                    [cardType]="getCardTypeForProfile(item)"
                    [canViewDetails]="canViewDetails()" />
                }
              }
            </a>
          } @else {
            @switch (getCardTypeForProfile(item)) {
              @case ('SUPPLIER') {
                <pwj-supplier-profile-card
                  [profile]="item"
                  [cardType]="getCardTypeForProfile(item)"
                  [canViewDetails]="canViewDetails()" />
              }
              @case ('INSTALLER') {
                <pwj-installer-profile-card
                  [profile]="item"
                  [cardType]="getCardTypeForProfile(item)"
                  [canViewDetails]="canViewDetails()" />
              }
              @case ('PROJECT_OWNER') {
                <pwj-developer-profile-card
                  [profile]="item"
                  [cardType]="getCardTypeForProfile(item)"
                  [canViewDetails]="canViewDetails()" />
              }
              @case ('ARCHITECT') {
                <pwj-architect-profile-card
                  [profile]="item"
                  [cardType]="getCardTypeForProfile(item)"
                  [canViewDetails]="canViewDetails()" />
              }
              @default {
                <pwj-supplier-profile-card
                  [profile]="item"
                  [cardType]="getCardTypeForProfile(item)"
                  [canViewDetails]="canViewDetails()" />
              }
            }
          }
        </li>
      }
    </ul>
    @if (count > 0) {
      <pwj-pagination
        class="profile-cards-list__pagination"
        [dataCount]="count"
        [perPage]="12" />
    }
  } @else if (list.length === 0 && !isLoading) {
    <pwj-no-content [message]="noContentMessageKey()" />
  } @else {
    <div class="profile-cards-list__skeletons">
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <div class="profile-cards-list__skeleton">
          <ngx-skeleton-loader
            [theme]="{
              width: '7.5rem',
              height: '7.5rem',
              'border-radius': '0.5rem',
            }" />
          <div class="profile-cards-list__skeleton-body">
            <ngx-skeleton-loader
              [theme]="{ height: '1.75rem', width: '70%' }" />
            <ngx-skeleton-loader
              [theme]="{ height: '1.25rem', width: '50%' }" />
            <ngx-skeleton-loader [theme]="{ height: '3rem', width: '100%' }" />
          </div>
        </div>
      }
    </div>
  }
</section>
